import React, { useEffect } from "react";
import FAQS from "../Components/FAQS";
import Hero from "../Components/Hero";
import HowWorks from "../Components/HowWorks";
import WhyUs from "../Components/WhyUs";
import Speciality from "../Components/Speciality";
import { Download } from 'lucide-react';
import { Link } from 'react-router-dom';

const Home = () => {
  useEffect(() => {
    const ScrollToTop = () => {
      window.scrollTo(0, 0);
    };
    ScrollToTop();
  }, []);

  return (
    <>
      <Hero />
      <HowWorks />
      <WhyUs />

      <section className="text-white py-5 mt-10" style={{ background: "#fc364e" }}>
        <div className="canvas py-3">
          <div className="row align-items-center">

            {/* LEFT SIDE */}
            <div className="col-md-6 text-center text-md-start mb-4 mb-md-0">
              <h2 className="fw-bold mb-3">
                Descarga nuestra app de envíos de dinero segura y fácil de usar
              </h2>
              <p className="mb-4">
                Envía dinero desde cualquier lugar con nuestra aplicación <strong>Transferven</strong>.
                Consulta tasa de cambio, repite un envío o envía una recarga telefónica.
              </p>

              <Link to="https://play.google.com/store/apps/details?id=com.transferven.app" target="_blank"
                className="btn btn-primary-custom d-inline-flex align-items-center gap-2 px-4 py-2">
                <Download size={18} />
                Descargar
              </Link>
            </div>

            {/* RIGHT SIDE */}
            <div className="col-md-6 text-center text-md-center">
              <h3 className={window.matchMedia("(max-width: 700px)").matches ? "display-1 fw-bold" : "fw-bold display-3"}>
                ¡Rápido,<br />
                Simple,<br />
                Seguro!
              </h3>
            </div>
          </div>
        </div>
      </section>
      <Speciality />

      <FAQS />
    </>
  );
};

export default Home;
